<template>
 	<v-row
 		:justify = "head.justify_init"
 		:align 	 = "head.align_init"

 	>
 		<v-col
 			:cols = "head.col_init"
 		>
 			<v-card outlined>
 				<v-card-title
 					:class = "head.class_title"
 				>
 					<v-icon 
						small 
						color  = "white"
						class  = "ml-1"
						@click = "$router.back()"
					>
						mdi-arrow-left-circle
					</v-icon>

					<v-spacer></v-spacer>
					<v-icon 
						small 
						color  = "primary"
						class  = "mx-2"
					>
						{{ head.icon_title }}
					</v-icon>
					<span 
						
					>
						{{ render_title }}
					</span>
					<v-spacer></v-spacer>
 				</v-card-title>
 				<v-card-text
 					:class = "head.class_text"

 				>
 					<v-progress-linear
						indeterminate
						color 	= "primary"
						v-show 	= "loading"
					></v-progress-linear>
 					<v-row 
 						dense
 					>
 							
	 					<template v-for = "(item_input, idx_input) of list_fields">
	 						<v-col
	 							:cols = "item_input.col"
	 							:key  = "ref + idx_input"
	 						>
	 							<v-text-field
	 								dense
	 								outlined
	 								hide-details

	 								v-if 			= "['text', 'number'].includes(item_input.type)"
	 								:type 			= "item_input.type"
	 								:class 			= "item_input.class"
	 								:label 			= "item_input.text"
	 								v-model 		= "info[item_input.key]"
	 								:placeholder 	= "item_input.placeholder"
	 							>
	 								<template v-slot:prepend-inner>
	 									<v-icon
	 										small
	 										:color = "item_input.color"
	 										:class = "item_input.class_icon"
	 									>
	 										{{ item_input.prepend_icon }}	
	 									</v-icon>
	 								</template>
	 							</v-text-field>
	 						
		 						<v-card 
									outlined 
									class 		= "pa-0 caption " 
									height 		= "40"
									
									v-if 	= "item_input.type == 'switch'">
									<v-switch			
										dense						
										hide-details
										:class 			= "item_input.class"			
										v-model 		= "info[item_input.key]"									
										:label 			= "item_input.text"
										:prepend-icon 	= "item_input.prepen_icon"
										:true-value 	= "item_input.value"
									></v-switch>
										
								</v-card>
								<v-select
									dense						
									outlined
									hide-details
									v-else-if 		= "item_input.type == 'select'"
									v-model 		= "info[item_input.key]"
									:label 			= "item_input.text"
									:items 			= "render_listeds(item_input.list)"
									:item-text 		= "item_input.item_text"
									:item-value 	= "item_input.item_value"
									:prepend-inner-icon 	= "item_input.prepend_icon"
								></v-select>
	 						</v-col>
	 					</template>
 					</v-row>
 				</v-card-text>
 				<v-divider></v-divider>
 				<v-card-actions>
 					<v-spacer></v-spacer>
 					<v-btn
 						x-small
 						:color = "head.class_btn"
 						@click = "actions(head.btn_action)"
 					>
 						{{ $ml.get(head.btn_action) }}
 					</v-btn>
 				</v-card-actions>
 			</v-card>
 		</v-col>
 	</v-row>
</template>
<script type="text/javascript">
 	export default {
 		name : "contact",
 		data : (vm) => ({
 			ref 		: "contact",
 			info 		: {},
 			info_item 	: null,
 			head 		: {
 				justify_init	: "center",
				align_init 		: "end",
				col_init		: "5",
				class_title 	: "justify-center body-1 secondary pa-1 white--text",
				title 			: vm.$ml.get("new_contact"),
				icon_title 		: "mdi-contacts",
				class_text 		: "pa-2 ",
				btn_action 		: "save",
				class_btn 		: "primary",


 			},
 			list_fields		: [
 				{
					key 			: "name",
					text 			: vm.$ml.get("name"),
 					type 			: "text",
 					class 			: "",
					placeholder 	: vm.$ml.get("name"),
					color 			: "white",
					class_icon 		: "",
					prepend_icon 	: "mdi-account-box",
					col 			: "12",
 				},
 				{
					key 			: "type",
					text 			: vm.$ml.get("type"),
 					type 			: "select",
 					class 			: "",
					placeholder 	: vm.$ml.get("type"),
					color 			: "white",
					class_icon 		: "",
					prepend_icon 	: "mdi-account-box",
					list 			: "types_profiles",
					item_text   	: "text",
					item_value 		: "key",
					col 			: "12",
 				},
 				/*{
					key 			: "isEmail",
					text 			: vm.$ml.get("send_email"),
 					type 			: "switch",
 					class 			: "mt-1 ml-1",
					placeholder 	: "",
					color 			: "",
					class_icon 		: "",
					prepend_icon 	: "",
					col 			: "4",
					value 			: true,
 				},*/
 				{
					key 			: "description",
					text 			: vm.$ml.get("description"),
 					type 			: "text",
 					class 			: "",
					placeholder 	: "",
					color 			: "",
					class_icon 		: "",
					prepend_icon 	: "mdi-image-text",
					col 			: "12",
					value 			: true,
 				},
 				{
					key 			: "address",
					text 			: vm.$ml.get("address"),
 					type 			: "text",
 					class 			: "",
					placeholder 	: "dir##-## ##",
					color 			: "white",
					class_icon 		: "",
					prepend_icon 	: "mdi-map-marker",
					col 			: "12",
 				},
 				/*{
					key 			: "date_birth",
					text 			: "date_birth",
 					type 			: "dates",
 					class 			: "",
					placeholder 	: "",
					color 			: "white",
					class_icon 		: "",
					prepend_icon 	: "mdi-calendar",
					col 			: "6",
 				},*/
 				/*{
					key 			: "photo",
					text 			: "photo",
 					type 			: "import",
 					class 			: "",
					placeholder 	: "",
					color 			: "white",
					class_icon 		: "",
					prepend_icon 	: "mdi-image",
					col 			: "6",
 				},*/
 				/*{
					key 			: "isWs",
					text 			: vm.$ml.get("send_ws"),
 					type 			: "switch",
 					class 			: "mt-1 ml-1",
					placeholder 	: "",
					color 			: "",
					class_icon 		: "",
					prepend_icon 	: "",
					col 			: "4",
 				},*/
 			
 				

 			],
 			bus 			: {},
 			loading 		: false,
 			types_profiles  : [
 				{
 					key  : "client",
 					text : vm.$ml.get("client"),
 				},
 				{
 					key  : "external_customer",
 					text : vm.$ml.get("external_customer"),
 				},
 				{
 					key  : "user",
 					text : vm.$ml.get("user"),
 				}, 				
 				{
 					key  : "other",
 					text : vm.$ml.get("other"),
 				}
 			]
 			

 		}), // data

 		created(){
 			this.render_info();

 		}, // created

 		computed : {
 			render_title: function(){
 				if (this.head.btn_action == "save"){
 					return this.head.title 	= this.$ml.get("new_profile");
 				}else{
 					return this.head.title 	= this.$ml.get("settings_contact");
 				}

 			}, // render title

 		}, // computed

 		methods : {
 			actions(act, item, opt){
 				if (act == "save") {
 					this.save();
 				}else
 				if (act == "update") {
 					this.update();
 				}
 			}, // actions

 			render_info(){
 				let temp = this.$Helper.get_local("profile_settings");
 				if (temp && temp.type != "new") {
 					this.head.btn_action 	= "update";  					
 					this.info = { ...temp };
 				}else{
 					this.head.btn_action 	= "save"; 
 				}
 			}, // render info

 			render_listeds(list){
 				if (list && this[list]) {
 					return this[list];
 				}
 			}, // render listed

 			save(){
 				if (!this.$store.getters["auth/permission"](this.$route.name || "profile_settings", "can_add", "profiles")) {
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_create") + " : " + (this.$ml.get(this.$route.name) || "profile_settings"),
					})						
					return false;
				}
 				const api 			= this.$URL + "/api/v1/profiles";
 				let info_up 		= { ...this.info };
 				info_up["state"] 	= true;
 				this.loading 	= true;
 				this.$axios.post(api, info_up).then(res => {
 					this.loading 	= false;
 					this.info 		= {};
 					this.$EventBus.$emit("notifications_modal",{
	 						type : "saved",
	 					})
 					this.$router.back();
 				}).catch(er => {
 					this.loading 	= false;
 					console.warn("Error create profiles : ", er)
 					this.$EventBus.$emit("notifications_modal",{
 						type 	: "error",
 						message : er
 					})
 				})
 			}, // save

 			update(){
 				if (!this.$store.getters["auth/permission"](this.$route.name || "profile_settings", "can_edit", "profiles")) {
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + (this.$ml.get(this.$route.name) || "profile_settings"),
					})						
					return false;
				}
 				let info_up 	= { ...this.info };
 				// console.log("CHEK INFO : ", info_up)
 				if (info_up && info_up.id) {

	 				const api 		= this.$URL + "/api/v1/profiles/" + info_up.id;
	 				this.loading 	= true;
	 				this.$axios.put(api, info_up).then(res => {
	 					this.loading 	= false;
	 					this.info 		= {};
	 					this.$EventBus.$emit("notifications_modal",{
	 						type : "updated",
	 					})
	 					this.$router.back();
	 				}).catch(er => {
	 					this.loading 	= false;
	 					console.warn("Error create profiles : ", er)
	 					this.$EventBus.$emit("notifications_modal",{
	 						type 	: "error",
	 						message : er
	 					})
	 				})
 				}else{
 					console.warn("Required ID for update profiles ", info_up)
 				}
 			}, // update

 			

 		}, // methods

 		beforeDestroy(){
 			this.$Helper.clear_bus(this.$EventBus, this.bus, "profiles");
 		}
 	}
</script>